// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"bc069860","888":"b5520064"}[chunkId] + ".chunk.css";
};